import { PROGRESS_NAME } from '../../../ui/shared/ui/vg-progress/vg-progress.component';

export const setProgressReducer = (
    _: string,
    { value }: { value: string },
): string => value;
